import {
  CreateElementDocument,
  CreateElementMutationVariables,
  FormElementFragmentDoc,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useCreateElement = () => {
  const [create, { loading }] = useMutation(CreateElementDocument, {
    extractorFn: (data) => data.formsMutations.createFormsElement,
    update(cache, { data }) {
      const formId = data?.formsMutations.createFormsElement.element?.formId
      if (formId) {
        cache.modify({
          id: `FormsForm:${formId}`,
          fields: {
            elements(existingElements) {
              const newElement = cache.writeFragment({
                data: data?.formsMutations.createFormsElement.element,
                fragment: FormElementFragmentDoc,
              })
              return [...existingElements, newElement]
            },
          },
        })
      }
    },
  })

  return {
    loading,
    create(variables: CreateElementMutationVariables) {
      return create({
        variables,
      })
    },
  }
}

export default useCreateElement
